import { multiLanguage } from "../../../dndElements"


// Helper function to handle multilingual labels
export const getLanguageLabel = (label: string | multiLanguage, language?: string): string => {
  if (typeof label === 'object') {
    if (language && label[language]) {
      return label[language] ?? label.en
    }
    return label.en
  }
  return label
}
